<ng-template #content>
  <tidy-wrapper [class]="isRightSideContent ? '' : 'vertical-center hasnt-top-nav'">
    <ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'desktop' }" />

    @if (loaded) {
      @if (!hasNonTrialPaidSubscription && !selectedPrivatePro && (bookingExperiment === 'rental-v1b' || bookingExperiment === 'rental-v2b') && viewData.frequency === 'One Time' && !isUpdatingSubscription) {
        <tidy-alert>
          <div style="background: rgba(0, 170, 186, 0.8); padding: 10px 5px 10px 5px; margin: -10px; border-radius: 5px;">
            <tidy-row [align]="'center'" class="extra-bottom-padding">
              <tidy-text
                [header]="'Upgrade to TIDY+ & Save 20%'"
                class="white" />
            </tidy-row>
            <tidy-row [align]="'center'" class="extra-bottom-padding">
              <tidy-text
                [actionBody]="'TIDY+ lets you save 20% booking per property per year, cancel anytime.'"
                class="white" />
            </tidy-row>
            <tidy-row [align]="'center'">
              <tidy-text
                [actionBody]="(viewData.price | tcurrency)"
                class="white" /><span>&nbsp;</span>
              <tidy-text
                [actionBody]="'for job (save 20%)'"
                class="white" /><br>
              <tidy-text
                [actionBody]="'$36 for 1 year TIDY+'"
                class="white" />
            </tidy-row>
            <tidy-row>
              <tidy-divider style="background: white; width: 150px; margin: auto" />
            </tidy-row>
            <tidy-row [align]="'center'" class="extra-bottom-padding">
              <tidy-text
                [actionBody]="(viewData.price + 3600 | tcurrency)"
                class="white" /><span>&nbsp;</span>.
              <tidy-text
                [actionBody]="'total today'"
                class="white" />
            </tidy-row>
            <tidy-row [align]="'center'" class="extra-top-padding vertical-align-center">
              <tidy-image
                [src]="'assets/img/discount.svg'"
                class="header-size" />
              <tidy-text
                (click)="updateSubscription(this)"
                [largeBody]="isUpdatingSubscription ? 'Remove TIDY+' : 'Add TIDY+'"
                class="white link"
                style="cursor: pointer" />
            </tidy-row>
            <tidy-row [align]="'center'" class="extra-top-padding">
              <tidy-text
                (click)="goToViewSubscriptions(this)"
                [actionBody]="'View Other Subscription Types'"
                class="white link"
                style="cursor: pointer" />
            </tidy-row>
          </div>
        </tidy-alert>
      }
      @if (!selectedPrivatePro && hasNonTrialPaidSubscription && viewData?.frequency === 'One Time' &&  bookingType !== 'add_one_time_job') {
        <tidy-alert>
          <div style="background: rgba(0, 170, 186, 0.8); padding: 10px 5px 10px 5px; margin: -10px; border-radius: 5px;">
            <tidy-row [align]="'center'">
              <tidy-text
                [actionBody]="'Saving 20% with your'"
                class="white" /><span>&nbsp;</span>
              <tidy-text
                [actionBody]="currentSubscription?.key | subscriptionType"
                class="white" /><span>&nbsp;</span>
              <tidy-text
                [actionBody]="'subscription!'"
                class="white" />
            </tidy-row>
          </div>
        </tidy-alert>
      }
    }

    <tidy-card>
      @if (loaded) {
        @if (!isRightSideContent) {
          <tidy-row [align]="'center'">
            <tidy-text
              [title]="'Confirm'" />
            @if (isRequestSubstitute) {
              <span>&nbsp;</span>
              <tidy-text
                [title]="'Substitute Request'" />
            }
          </tidy-row>
        }
        @if (flowType === 'private') {
          <tidy-row [align]="'center'" class="extra-bottom-padding">
            <tidy-text
              [body]="'Booking with'" /><span>&nbsp;</span>
            <tidy-text
              [body]="proName | titlecase"
              [translate]="false" /><span>&nbsp;</span>
            <tidy-text
              [body]="'from'" />
            <tidy-text
              [body]="proTeamName | titlecase"
              [translate]="false" />
          </tidy-row>
        }
        @if (flowType !== 'private' && proName && !isProRequest) {
          <tidy-row [align]="'center'" class="extra-bottom-padding">
            <tidy-text
              [header]="'Booking with'" /><span>&nbsp;</span>
            <tidy-text
              [header]="proName"
              [translate]="false" />
          </tidy-row>
        }
        @if (isProRequest) {
          <tidy-row [align]="'center'" class="extra-bottom-padding">
            <tidy-text
              [header]="'Sending Request to '" />
            <tidy-text
              [header]="proName"
              [translate]="false" />
          </tidy-row>
        }
        <div class="summary-item">
          <tidy-image
            [src]="'assets/svg/location-outline.svg'"
            class="summary-icon" />
          <div class="summary-text">
            <tidy-text [helper]="'Location'" />
            <tidy-text [body]="address?.address_name || (address?.address1 + (address?.address2 ? ' ' + address?.address2 : ''))" [translate]="false" />
          </div>
        </div>
        <div class="summary-item">
          <tidy-image
            [src]="viewData?.isHouseCleaning ? 'https://d30thx9uw6scot.cloudfront.net/svgs/regular_cleaning.svg' : (viewData?.image || 'assets/svg/home-outline.svg')"
            class="summary-icon" />
          <div class="summary-text">
            <tidy-text [helper]="'Service'" />
            <tidy-text [body]="(viewData?.service | titlecase) + (viewData?.frequency ? ' · ' + viewData.frequency : '')" />
          </div>
        </div>
        @if (!isProRequest && !isJobRequest) {
          <div class="summary-item">
            <tidy-image
              [src]="'assets/svg/calendar-outline.svg'"
              class="summary-icon" />
            <div class="summary-text">
              <tidy-text [helper]="'Date & Time'" />
              @if (isRequestSubstitute && viewData?.dateTimes?.length) {
                @for (dateTime of viewData.dateTimes; track $index) {
                  <tidy-text [body]="dateTime" />
                }
              } @else {
                <tidy-text [body]="viewData?.dateTime" />
                @if (viewData?.dateTimeTwo) {
                  <tidy-text [body]="viewData?.dateTimeTwo" />
                }
                @if (viewData?.dateTimeThree) {
                  <tidy-text [body]="viewData?.dateTimeThree" />
                }
              }
            </div>
          </div>
        }
        @if (isJobRequest) {
          <div class="summary-item">
            <tidy-image
              [src]="'assets/svg/calendar-outline.svg'"
              class="summary-icon" />
            <div class="summary-text">
              <tidy-text [helper]="'Date & Time'" />
              <tidy-text
                [body]="('Earliest: ' | translate) + (requestDates?.startDate | parseDateTime:'ddd MMM d') + ' ' + (bookData?.booking?.start_time_no_earlier_than | parseDateTime:'h:mma')" />
              <tidy-text
                [body]="('Latest: ' | translate) + (requestDates?.endDate | parseDateTime:'ddd MMM d') + ' ' + (bookData?.booking?.end_time_no_later_than | parseDateTime:'h:mma')" />
            </div>
          </div>
        }
        @if (isProRequest) {
          <div class="summary-item">
            <tidy-image
              [src]="'assets/svg/calendar-outline.svg'"
              class="summary-icon" />
            <div class="summary-text">
              <tidy-text [helper]="'Times Requested'" />
              @for (time of (params?.payload?.request_time_blocks | requestTimeRangeList); track time) {
                <tidy-text [body]="time" />
              }
            </div>
          </div>
        }
        <div class="summary-item">
          <tidy-image
            [src]="'assets/svg/cash-outline.svg'"
            class="summary-icon" />
          <div class="summary-text">
            <tidy-text [helper]="'Price'" />
            @if (viewData?.billingType === 'price_later') {
              <tidy-text
                [body]="'This type of job is typically priced after. We\'ll find the best pro and you can discuss pricing with them.'" />
            } @else if (displayPrice && (!hasPrivatePros && !hasNoPrivatePros || hasNoPrivatePros && !hasPrivatePros)) {
              <tidy-text [body]="displayPrice" />
            }
            @if (!selectedPrivatePro && priceExperiment === 'showCrossedOutDiscount' && viewData?.frequency !== 'One Time') {
              <tidy-text [body]="'*Saving 20% with recurring plan'" />
            }
            @if (!selectedPrivatePro && isUpdatingSubscription) {
              <tidy-text
                [body]="'*' + (viewData?.price | tcurrency) + (' for job (saving 20%)' | translate)" />
              <tidy-text
                [body]="(currentSubscription?.amount | tcurrency) + (' for ' | translate) + (currentSubscription?.key | subscriptionType)" />
              <tidy-text
                [body]="'remove'"
                class="link"
                (action)="updateSubscription()" />
            }
          </div>
        </div>
      }

      <div [style.display]="cardDeclined ? 'block' : 'none'">
        <tidy-error-message
          [text]="cardError" />
        <ion-card-content>
          <form class="checkout">
            <ion-label position="stacked">Enter Card Information</ion-label>
            <div class="form-row">
              <div id="card-info" #cardInfo></div>
            </div>
          </form>
        </ion-card-content>
      </div>

      @if (loaded && showSameDayTimeAlert && (!hasPrivatePros && !hasNoPrivatePros || hasNoPrivatePros && !hasPrivatePros)) {
        <tidy-row class="extra-bottom-padding">
          @if (sameDayPrice !== 0) {
            <tidy-text
              [body]="'<b>*Note:</b> You selected times today. If a Pro accepts a time today <u>the job price will be'" /><span>&nbsp;</span>
            <tidy-text
              [body]="(sameDayPrice | tcurrency) + '</u>.'" />
          }
          @if (sameDayPrice == 0) {
            <tidy-text
              [body]="'<b>*Note:</b> You selected times today. If a Pro accepts a time today <u>the price will be +50%</u>.'" />
          }
        </tidy-row>
      }
    </tidy-card>

    @if (loaded) {
      <tidy-row class="align-right extra-top-padding">
        <tidy-button
          [text]="'Go Back'"
          [action]="boundGoBack"
          class="secondary" />
        <tidy-button
          [text]="buttonTitle"
          [action]="boundConfirmBooking"
          [submitted]="submitted"
          [disabled]="disableSubmit"
          class="primary" />
      </tidy-row>
    }

    @if (loaded) {
      @if (showNeedsToRaisePricesError) {
        <tidy-alert>
          <tidy-row [align]="'center'">
            <tidy-image
              [src]="'assets/svg/alert-circle.svg'"
              class="header-size" />
            <tidy-text
              [header]="'Unable to Book'" />
          </tidy-row>
          <tidy-row [align]="'center'">
            <tidy-text
              [body]="'This pro has raised their rates. To book them directly, you would need to increase your price to'" /><span>&nbsp;</span>
            <tidy-text
              [body]="((viewData.frequency === 'One Time' && bookingType === 'add_job' ? addressTier?.amount*1.1 : addressTier?.amount)  | tcurrency) + '.'" />
          </tidy-row>
          <tidy-row>
            <tidy-button
              [text]="('Raise My Price to ' | translate) + ((viewData.frequency === 'One Time' && bookingType === 'add_job' ? addressTier?.amount*1.1 : addressTier?.amount)  | tcurrency) + (' & Book' | translate)"
              [action]="boundAddEditJobPlanRaisePrices"
              class="primary" />
          </tidy-row>
          <tidy-row>
            <tidy-button
              [text]="'Try for Another Pro at These Prices'"
              [action]="boundAddEditJobPlanWithAnyPro"
              class="secondary" />
          </tidy-row>
        </tidy-alert>
      }
      @if (triedOtherProsError) {
        <tidy-row class="extra-top-padding">
          <tidy-error-message
            [text]="'Unfortunately no other pro is available at this price. You need to raise your price to book this job.'" />
        </tidy-row>
      }
      @if (errorMessage) {
        <tidy-row class="extra-top-padding">
          <tidy-error-message
            [text]="errorMessage" />
        </tidy-row>
      }
    }

  </tidy-wrapper>
</ng-template>

@if (!isRightSideContent) {
  <app-scroll-wrapper [templateContent]="content" />
}

@if (isRightSideContent) {
  <ion-content class="ion-content-right-column">
    <ng-container *ngTemplateOutlet="content" />
  </ion-content>
}
